import { gql } from '@apollo/client';

const UNREVIEWED_REPORT_COUNT_QUERY = gql`
  query unreviewedReportCount($filter: UnreviewedReportsFilterInput) {
    unreviewedReportCount(filter: $filter) {
      isSuccess
      message
      count
    }
  }
`;

export default UNREVIEWED_REPORT_COUNT_QUERY;
